import TRadio from './radio.vue'
import TRadioGroup from './radio-group.vue'

TRadio.install = Vue => {
  Vue.component(TRadio.name, TRadio)
}

TRadioGroup.install = Vue => {
  Vue.component(TRadioGroup.name, TRadioGroup)
}

export {
  TRadio,
  TRadioGroup
}



// WEBPACK FOOTER //
// ./src/module/radio/index.js